module.exports = "##### Overlay\n\nWe use overlays to draw attention to a particular part of the UI, like a Modal or a Drawer.\n"